export const SHORT_TITLE = "Marc Rudin";
export const LONG_TITLE = "Marc Rudin Archive";